import {ReactComponent as Icon} from '@image/icon_title.svg';

const IconTitle = () => {
    return   <Icon />;
};

export default IconTitle;